import { getCMSConfig } from '../cms';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { getOptionPageUrl, getProductPageUrl } from '../url';
import { HomesPassedType, ProductType } from '../../enums/product';
import { IButtonProperties } from '@vfde-brix/ws10/button';
import { AvcResult } from '@vfde-sails/avc-core';
import { updateFloatingMobileNotification } from '../../components/sticky-button';

const getPreAvcButtonProps = (onClick?: () => void): Partial<IButtonProperties> => ({
    stdContent: getCMSConfig().offerSummaryCard.button.avc,
    linkHref: undefined,
    business: { onClick },
});

const getPreMarketingButtonProps = (
    tariffId: string,
    homesPassedType?: HomesPassedType,
): Partial<IButtonProperties> => {
    if (homesPassedType === HomesPassedType.BHS) {
        const { text, link } = getCMSConfig().offerSummaryCard.button.hotline;

        return {
            linkHref: link,
            stdContent: text,
            business: NO_PATTERN_BUSINESS_LOGIC,
        };
    }

    return {
        linkHref: getOptionPageUrl(tariffId),
        stdContent: getCMSConfig().offerSummaryCard.button.option,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
};

/**
 * Gets the props that need to be
 * updated for the price button
 * @param tariffId - Id of the selected tariff
 * @param avcResult - Result of the avc, if there is
 * @param onClick - OnClick event
 * @returns Props to update
 */
export const getUpdatedPriceButtonProps = (
    tariffId: string | undefined,
    avcResult?: AvcResult,
    onClick?: () => void,
    isPreFiber?: boolean,
    homesPassedType?: HomesPassedType,
): Partial<IButtonProperties> => {
    if (!tariffId) {
        updateFloatingMobileNotification(true);
        return {};
    }

    if (!avcResult) {
        updateFloatingMobileNotification(true);
        return getPreAvcButtonProps(onClick);
    }

    if (isPreFiber || homesPassedType) {
        updateFloatingMobileNotification(true);
        return getPreMarketingButtonProps(tariffId, homesPassedType);
    }

    const { fiber, cable, dsl, gigacube } = getCMSConfig().avcResult;
    const { fastest } = avcResult;
    const { button } = (() => {
        switch (fastest?.productType) {
            case ProductType.FIBER:
                updateFloatingMobileNotification(true);
                return fiber;
            case ProductType.CABLE:
                updateFloatingMobileNotification(false);
                return cable;
            case ProductType.DSL:
                updateFloatingMobileNotification(false);
                return dsl;
            default:
                updateFloatingMobileNotification(false);
                return gigacube;
        }
    })();

    return {
        linkHref: fastest
            ? getProductPageUrl(fastest.productType, fastest.id)
            : gigacube.link,
        stdContent: button,
        business: NO_PATTERN_BUSINESS_LOGIC,
    };
};
